import { Helmet } from "react-helmet-async";


const routeMetaData = {
	"home": {
		title: "ViolinScope | Visual Violin Learning Made Easy",
		description: "ViolinScope — a free, visual way for kids to learn violin at home with fun games, simple resources, and tools to build confidence in reading music.",
	},
	"flashcards": {
		title: "ViolinScope | Simple Flashcards Helping You Read Notes Faster",
		description: "Online flashcards grouped by ranges for you to choose to help you learn the names of musical notes commonly found in your music.",
		// keywords: "free online flashcards, piano, violin, beginner, game, score, fun, time, learn name of musical notes, fundaments, reading, sight-read",
		// canonicalLink: "/flashcards"
	},
	"violinTuner": {
		title: "ViolinScope | Simple Tuner Designed For Violin",
		description: "Use the EasyTune tool to help you tune violin with visual and sound guidance.",
		// keywords: "free online flashcards, piano, violin, beginner, game, score, fun, time, learn name of musical notes, fundaments, reading, sight-read",
		// canonicalLink: "/flashcards"
	},
		"sightPlay": {
		title: "ViolinScope | Test Sight-Reading and Intonation Skills With SightPlay Challenge",
		description: "Learn by taking the SightPlay Challenge to test your violin skills — see how many notes you can get right!",
		// keywords: "interactive game, violin, play, fun, learn violin, finger pattern, sound, fingerboard, name of notes, fingering, string, practice, practise, beginner, read, sight-read",
		// canonicalLink: "/practice"
	},
	"learn": {
		title: "ViolinScope | Learn Violin Finger Patterns Visually",
		description: "Master left-hand finger patterns on the violin with visual guides and clear explanations. Build a strong foundation for playing in different keys.",
		// keywords: "understand violin finger patterns, semitone, whole tone, keys, flat, sharp, violin, learn",
		// canonicalLink: "/learn"
	},
	"practice": {
		title: "ViolinScope | Practice Reading and Navigation With Fun Games",
		description: "Practice note-reading by naming notes, matching them to the right string and finger, and navigate them on the visual fingerboard - it is a fun, interactive game and great for beginners.",
		// keywords: "interactive game, violin, play, fun, learn violin, finger pattern, sound, fingerboard, name of notes, fingering, string, practice, practise, beginner, read, sight-read",
		// canonicalLink: "/practice"
	},
	// "videoLearning": {
	// 	title: "ViolinScope | Vidoes demonstrating correct set-ups and techniques",
	// 	description: "Watch and play along with these video clips to help you set-up, learn, and practice all the essential practical skills to become a fantastic virtuoso.",
	// },
	"about": {
		title: "ViolinScope | About, contact and donate",
		description: "Information about ViolinScope and its author, how to contact us or make a donations",
		// keywords: "about, Joanne Chen, London violin teacher, violinist, coder, free education, donate, contact VioinScope, lesson, learning, feedback, appreciation, ",
		// canonicalLink: "/about"
	}
}
const SEO = (props) => {
	const {pageName} = props;

	return (
		<Helmet>
			<title>{routeMetaData[pageName].title}</title>
			<meta name="description" content={routeMetaData[pageName].description}/>
			{/* <meta name="keywords" content={routeMetaData[pageName].keywords} />  */}
			{/* <link rel="canonical" href={routeMetaData[pageName].canonicalLink} /> */}
		</Helmet>
	)
}

export default SEO;